export default {
  statistics: {
    total_followers: 'Seuraajia yhteensä',
    emails_sent: 'Sähköposteja lähetetty',
    emails_opened: 'Sähköposteja avattu',
    emails_clicked: 'Sähköposteja klikattu',
    emails_average_open_rate: 'Sähköpostien avausprosentti',
    emails_average_click_rate: 'Sähköpostien klikkausprosentti',
    push_notifications_sent: 'Push-ilmoitukset lähetetty',
    push_notifications_clicked: 'Push-ilmoitukset napsautettu',
  },
};
